import * as React from 'react';
import classNames from 'classnames';
import styles from './Checkbox.module.scss';

export interface ICheckboxProps {
  checked: boolean;
  onChange(newChecked: boolean): void;
  label: string | JSX.Element;
  className?: string;
  disabled?: boolean;
}

/**
 * A custom styled checkbox.
 */
const Checkbox = ({ checked, onChange, label, className, disabled }: ICheckboxProps) => (
  <label className={classNames(styles.checkbox, className)}>
    <input type="checkbox" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
    <span className={styles.checkboxIcon} />
    {label}
  </label>
);

export default Checkbox;
